export default __webpack_public_path__ + "static/header_placeholder_optimized-912099a0f224fd62475906036831fd7b.jpg";